import React, { useCallback, useEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";

import { includesInsensitive } from "util/string";

import DefaultEntityCrud from "components/form/DefaultEntityCrud";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import FormContent from "components/form/FormContent";
import FormRow from "components/form/FormRow";
import SelectInput from "components/form/input/SelectInput";
import TextInput from "components/form/input/TextInput";
import DebugObjComp from "components/DebugObjComp";
import DataTable from "components/DataTable";

import { fetchArray } from "entity";
import ProdutoEntity from "entity/Produto";
import GrupoEntity from "entity/Grupo";
import { Switch, Typography } from "@mui/material";

const ProdutoFormInter = (props) => {
    const [filtrarPorNome, setFiltrarPorNome] = useState(false);
    const { nome, grupo } = props.values;

    const [produtos, setProdutos] = useState([]);
    // const [filteredProdutos, setfilteredProdutos] = useState([])

    const [searchParams] = useSearchParams();
    const searchUid = searchParams.get("uid");

    const loadProdutos = useCallback(async () => {
        let result = await fetchArray(ProdutoEntity.getAll());

        setProdutos(result);

        // if (nome && nome.length) {
        //     setfilteredProdutos(result.filter(p => includesInsensitive(p.nome, nome)))
        // } else if (searchUid) {
        //     setfilteredProdutos(result.filter(p => p.uid === searchUid))
        // } else {
        //     setfilteredProdutos(result)
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let filteredProdutos = [];

    if (grupo) {
        filteredProdutos = produtos.filter((p) => p.grupo?.nome.toUpperCase() === grupo?.nome.toUpperCase());
    } else {
        filteredProdutos = produtos;
    }
    if (filtrarPorNome) {
        if (nome && nome.length) {
            filteredProdutos = produtos.filter((p) => includesInsensitive(p.nome, nome));
        }
    }
    // console.log('filteredProdutos',filteredProdutos)

    useEffect(() => {
        loadProdutos();
    }, [loadProdutos]);

    // lista e função de filtrar
    useEffect(() => {
        let i = produtos.map((p) => p.uid).indexOf(searchUid);

        // item atualizado
        let obj = props.values;
        obj.nome = obj.nome?.toUpperCase();

        if (searchUid) {
            obj.uid = searchUid;
        }

        // >>> trabalhando com a tabela <<<
        // não existe o item na tabela
        if (i === -1) {
            // acabou de salvar o item no bd, então devo adicioná-lo na tabela
            if (searchUid) {
                setProdutos([obj, ...produtos]);
            }
        }
        // existe o item na tabela
        else {
            let a = produtos;
            a[i] = obj;

            setProdutos(a);
        }

        // >>> trabalhando com o filtro <<<
        // if (nome) {
        //     let filtro = produtos.filter(p => includesInsensitive(p.nome, nome))

        //     if (grupo) {
        //         filtro = filtro.filter(p => p.grupo.nome.toUpperCase() === grupo.nome.toUpperCase())
        //     }

        //     setfilteredProdutos(filtro)
        // } else {
        //     if (grupo) {
        //         setfilteredProdutos(produtos.filter(p => includesInsensitive(p.grupo.nome, grupo.nome)))
        //     } else {
        //         setfilteredProdutos(produtos)
        //     }
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nome, grupo, searchUid, produtos]);

    return (
        <>
            <FormContent sx={{ m: 1 }}>
                <FormRow>
                    <EntitySearchInput
                        name="grupo"
                        label="Grupo"
                        EntityClass={GrupoEntity}
                        stringFieldOrderBy="nome"
                        required
                    />
                </FormRow>
                <FormRow>
                    <SelectInput
                        sx={{ flex: 0.5 }}
                        name="status"
                        label="Status"
                        options={["ATIVO", "INATIVO"]}
                        required
                    />
                    <TextInput sx={{ flex: 2 }} name="nome" label="NOME DO PRODUTO" required />
                </FormRow>
                <FormRow>
                    <TextInput sx={{ flex: 2 }} name="descricao" label="DESCRIÇÃO DO PRODUTO" multiline />
                </FormRow>
            </FormContent>
            <div style={{ paddingLeft: 25, display: "flex", alignItems: "center" }}>
                <Switch checked={filtrarPorNome} onChange={(b) => setFiltrarPorNome(!filtrarPorNome)} />
                <Typography>Filtrar Produtos por Nome</Typography>
            </div>
            <Typography style={{ padding: 5 }} variant="h6">
                Produtos Cadastrados no Grupo
            </Typography>
            <DataTable
                columns={ProdutoEntity.searchColumns}
                rows={filteredProdutos}
                autoHeight
                // onRowClick={row => navigate("/produto?uid=" + row.uid)}
                sx={{
                    "& .MuiDataGrid-row:hover": {
                        cursor: "pointer",
                    },
                }}
            />
            <DebugObjComp colection={ProdutoEntity.collectionUID} uidObj={props.values?.uid} values={props.values} />
        </>
    );
};
export default function ProdutoForm() {
    return (
        <DefaultEntityCrud
            EntityClass={ProdutoEntity}
            title={"Produto"}
            routeForm="produto"
            backRoute="consulta-produto"
            formActions={{ novoForm: true, salvarForm: true, sairForm: true }}
        >
            {(props) => {
                return <ProdutoFormInter {...props} />;
            }}
        </DefaultEntityCrud>
    );
}
